import axios from '@/request';
import qs from 'qs';

export default {
  async selWebsites(params: any) {
    return axios.get('adserver/websites/sel', { params });
  },
  async websites(params: any) {
    return axios.get('adserver/websites/list', { params });
  },
  async addWebsite(params: any) {
    return axios.post('adserver/websites/add', qs.stringify(params));
  },
  async editWebsite(params: any) {
    return axios.post('adserver/websites/edit', qs.stringify(params));
  },
  async detailWebsite(params: any) {
    return axios.get('adserver/websites/detail', { params });
  },
  async deleteWebsite(params: any) {
    return axios.post('adserver/websites/delete', qs.stringify(params));
  },
  async zones(params: any) {
    return axios.get('adserver/zones/list', { params });
  },
  async addZone(params: any) {
    return axios.post('adserver/zones/add', qs.stringify(params));
  },
  async editZone(params: any) {
    return axios.post('adserver/zones/edit', qs.stringify(params));
  },
  async detailZone(params: any) {
    return axios.get('adserver/zones/detail', { params });
  },
  async deleteZone(params: any) {
    return axios.post('adserver/zones/delete', qs.stringify(params));
  },
  async banners(params: any) {
    return axios.get('adserver/banners/list', { params });
  },
  async addBanner(params: any) {
    return axios.post('adserver/banners/add', qs.stringify(params));
  },
  async editBanner(params: any) {
    return axios.post('adserver/banners/edit', qs.stringify(params));
  },
  async detailBanner(params: any) {
    return axios.get('adserver/banners/detail', { params });
  },
  async deleteBanner(params: any) {
    return axios.post('adserver/banners/delete', qs.stringify(params));
  },
  async deliveryOptions(params: any) {
    return axios.get('adserver/delivery-options', { params });
  },
  async saveDeliveryOptions(params: any) {
    return axios.post('adserver/save-delivery-options', qs.stringify(params));
  },
  async selZones(params: any) {
    return axios.get('adserver/websites/selzones', { params });
  },
  async trackers(params: any) {
    return axios.get('adserver/trackers/list', { params });
  }
};
